export const getShoppingCartTextLinkManual = state => {
  return state.link_manual
}



// WEBPACK FOOTER //
// ./src/store/modules/shopping_cart_text/getters.js